import React from 'react'

function CRMDashboard() {
  return (
    <div className='rounded-lg bg-white p-3' >CRMDashboard</div>
  )
}

export default CRMDashboard